import axiosInstance from "./axiosInstance";

const obtenerReservaciones = async (id, includeExpired = false, startDate = null, endDate = null, reservationType = null, page=null) => {
  let params = {
    titularId: id,
  }
  if (startDate) {
    params['startDate'] = startDate;
  }
  if (endDate) {
    params['endDate'] = endDate;
  }
  if (includeExpired) {
    params['includeExpired'] = includeExpired;
  }
  if (reservationType) {
    params['reservationType'] = reservationType;
  }
  if (page) {
    params['page'] = page;
  }
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerReservaciones`,
    {
      params: params,
      withCredentials: true,
    }
  );
};

export default obtenerReservaciones;
